import * as s from './styles';

import type { IMoreCards } from './types';

const MoreCards = ({ moreCards, headline }: IMoreCards) => (
  <s.StyledContainer>
    <s.HeadlineContainer>
      {headline && (
        <s.StyledHeadline
          forwardedAs="h2"
          variant='h4'
        >
          {headline}
        </s.StyledHeadline>
      )}
    </s.HeadlineContainer>
    <s.CardsContainer>
      {moreCards.map((card) => <s.StyledMoreCard key={card.eyebrow} {...card} />)}
    </s.CardsContainer>
  </s.StyledContainer>
);

export default MoreCards;
